import { Text, VStack } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import APButton from "../../../components/APButton";
import { TranslationsId, useVocabIntl } from "../../../hooks/useVocabTranslation";

const CallToLoginView = ({ heading = "login-and-follow-your-progress" }: { heading?: TranslationsId }) => {
  const navigate = useNavigate();
  const { APFormattedMessage } = useVocabIntl()

  return (
    <VStack position={"relative"} padding={4} gap={2}>
      <Text fontWeight={"normal"} lineHeight={1.5} textAlign={"center"}>
        <APFormattedMessage
          id={heading}
        />
      </Text>
      <APButton size={"lg"}
                onClick={() => navigate("/", { replace: true, state: { instantLogin: true } })}>
        <APFormattedMessage id={"login"} />
      </APButton>
      <APButton size={"lg"} colorScheme={"secondary"}
                onClick={() => navigate("/", { replace: true, state: { instantRegister: true } })}>
        <APFormattedMessage id={"create-account"} />
      </APButton>
    </VStack>
  )
}

export default CallToLoginView;